module.exports = __webpack_public_path__ + "static/media/18ECA7.62b9c3cc.jpg";